import React from "react";
import {
  makeStyles,
  Box,
  Typography,
  Divider,
  Button,
  Tabs
} from "@material-ui/core";
import CustomTab from "components/tab";
import ChevronRightRoundedIcon from "@material-ui/icons/ChevronRightRounded";
import MyDealerListPanel from "modules/stockflow/components/panel/myDealerListPanel";
import { TabPanel, allyProps } from "components/tabPanel";

import { AddIcon } from "components/icon";
import { getLang } from "app/feature/constants";

const useStyle = makeStyles(theme => ({
  paper: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(5, 0),
    width: "90%",
    maxWidth: 1000,
    display: "inherit",
    justifyContent: "inherit"
  },
  content: {
    width: "95%",
    maxWidth: 850
  },
  indicator: {
    border: "0.5px solid",
    borderColor: theme.palette.primary.main
  },
  scroll: {
    width: "min-content"
  }
}));

export default function MyDealerPage({
  canCreateDealer,
  isInviteDialogOpen,
  handleVisibleInviteDialog,
  lang
}) {
  const classes = useStyle();

  return (
    <Box>
      <Box gridArea="top">
        <Box>
          <Box
            mb={1}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box display="flex" alignItems="flex-end" fontWeight="bold">
              <Typography variant="h6" color="primary">
                {getLang(lang, 'label.STOCKFLOW')}
              </Typography>
              <Box mx={0.5}>
                <ChevronRightRoundedIcon color="disabled" />
              </Box>
              <Typography variant="h6" color="primary">
                {getLang(lang, 'label.MY_DEALER')}
              </Typography>
            </Box>
            <Box>
              {
                canCreateDealer
                  ?
                  <Button
                    variant="text"
                    color="primary"
                    startIcon={
                      <AddIcon color="secondary" style={{ fontSize: "13px" }} />
                    }
                    onClick={() => handleVisibleInviteDialog(true)}
                  >
                    {getLang(lang, 'label.INVITE_DEALER')}
                  </Button>
                  : null
              }
            </Box>
          </Box>
          <Divider />
        </Box>
      </Box>

      <Box gridArea="main">
        <Tabs
          value={0}
          aria-label="scrollable auto tabs example"
          textColor="primary"
          variant="scrollable"
          indicatorColor="primary"
          classes={{
            indicator: classes.indicator,
            scrollButtons: classes.scroll
          }}
        >
          <CustomTab {...allyProps(0, getLang(lang, 'label.MY_DEALER'))} />
        </Tabs>
        <TabPanel value={0} index={0}>
          <React.Fragment>
            <MyDealerListPanel
              isInviteDialogOpen={isInviteDialogOpen}
              handleVisibleInviteDialog={handleVisibleInviteDialog}
            />
          </React.Fragment>
        </TabPanel>
      </Box>
    </Box>
  );
}